import { connectRouter, routerMiddleware } from 'connected-react-router'
import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { loadState, saveState } from 'core/utils/statePersistence'
import history from './history'
import rootReducer from './reducers'

const composeEnhancers =
  typeof window === 'object' &&
  process.env.NODE_ENV === 'development' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 })
    : compose

const enhancer = composeEnhancers(
  compose(applyMiddleware(routerMiddleware(history), thunk))
)

const persistedState = loadState()
const store = createStore(connectRouter(history)(rootReducer), persistedState, enhancer)
store.subscribe(() => {
  saveState(store.getState())
})

export default store
